import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { useConfiguration } from '../../../hooks/Configuration';
import { ALERT_INTERRUPTED } from '../../../constants/global';

interface IAlertProps {
}

function Alert(props: IAlertProps) {
    const configuration = useConfiguration();
    const [show, setShow] = useState(true);

    if (!show) return null;

    return (
        <div id='stx-chatbot-alert'>
            <div
                id='stx-chatbot-alert-close'
                onClick={() => {
                    setShow(false);
                    sessionStorage.setItem(ALERT_INTERRUPTED, true.toString());
                }}>
                <FontAwesomeIcon
                    icon={icon({ name: 'xmark' })}
                    size='sm' />
            </div>
            {configuration?.texts.alert}
        </div>
    );
}

export default Alert;
